import ReactOTPInput from 'react-otp-input';

import { OTPContainer, OTPInputCell } from './OTPInput.styled';

type OTPInputProps = {
  value: string;
  onChange: (value: string) => void;
  length?: number;
  disabled?: boolean;
};

export function OTPInput({
  disabled,
  length = 6,
  value,
  onChange,
}: Readonly<OTPInputProps>) {
  return (
    <OTPContainer>
      <ReactOTPInput
        value={value}
        onChange={onChange}
        numInputs={length}
        renderInput={props => (
          <OTPInputCell disabled={disabled} {...props} inputMode="numeric" />
        )}
        containerStyle="ReactOTPInput"
      />
    </OTPContainer>
  );
}
